<script>
  import { layoutMethods, exportMethods, erpFixMessages, erpUserRolesMethods, coreEloadNetworkMethods } from '@/state/helpers';
  import Swal from 'sweetalert2';
  import { required } from "vuelidate/lib/validators";
  import { getModuleAccess } from '@/router/helper.js'

  /**
   * Network component
   */
  export default {
    page: {
      title: "Network Group",
    },
    data() {
      return {
        title: "Network Group",
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
        filter: null,
        filterOn: [],
        sortBy: "value",
        sortDesc: false,
        submitted: false,
        fieldsNetwork: [
          {
            key: 'name',
            sortable: true
          },
          {
            key: 'image',
            sortable: false
          },
          {
            key: 'status',
            sortable: true
          },
        ],
        name: "",
        id:0,
        deleteNetworkName: "",
        itemsNetwork: [],
        formExitChecker:"",
        searchValue: {
          searchField: null,
          search: "",
          sort: 'id',
          orderDesc: true,
          status : null
        },
        statusList: [
          { text: "All", value: null },
          { text: "Active", value: 'a' },
          { text: "Inactive", value: 'i' }
        ],
        searchListNetwork: [{ text: "Network Name", value: null }],
        eloadNetworkGroupModule: {
          access: {
            create: true,
            delete: true
          }
        },
        networkList: [],
        networkListTotal: 0
      };
    },
    validations:{
      name:{required}
    },
    computed: {
      ...erpFixMessages,
      rows() {
        return this.itemsNetwork.length
      }
    },
    async mounted() {
      this.getNetworkGroupList();
      this.changeTitle({title: 'Network Group'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'E-Load Core Manager', to: { name: 'E-Load Core Provider'} },
          { text: 'E-Load Networks', to: { name: 'E-Load Core Network'} }
        ]
      });

      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Products', 'eLoad', 'eLoad Networks')
      .then((access) => this.eloadNetworkGroupModule.access = access);

    },
    methods: {
      ...layoutMethods,
      ...exportMethods,
      ...erpUserRolesMethods,
      ...coreEloadNetworkMethods,
      async getNetworkGroupList() {
        try {
          const response = await this.actionCoreEloadNetworkAPIPOST({
            params: {
              page: this.currentPage,
              rows: this.perPage,
              ...this.searchValue
            },
            action: 'listall'
          });
          
          if (response.status === 'ok') {
            this.networkList = response.message.rows;
            this.networkListTotal = response.message.pageInfo.total;
          }
        } catch (error) {
          console.error('Error fetching network list:', error);
          this.$alertify.error('Failed to fetch network list');
        }
      },
      leaveform(modal){
          if(JSON.stringify(this.name) == JSON.stringify(this.formExitChecker)){
              this.$bvModal.hide(modal)
              this.formExitChecker = ''
              return;
          }
          Swal.fire({
              title: 'Are you sure?',
              text: "you want to leave this page?",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '##804997',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No'
          }).then((result) => {
              if (result.isConfirmed) {
                  this.formExitChecker = ''
                  this.$bvModal.hide(modal)
              }else{
                  return;
              }
          })
      },
      onPageUpdate(reset = "") {
        if(reset == "reset"){
          this.currentPage = 1
        }
        this.getNetworkGroupList()
      },
      onSearch() {
        this.currentPage = 1
        if (this.searchValue.search) {
          this.searching = true
        } else {
          this.searching = false
        }
        this.getNetworkGroupList()
      },
      eloadNetworkSort(ctx){
        this.searchValue.sort = ctx.sortBy;
        this.searchValue.orderDesc = ctx.sortDesc;
        console.log(">> sorting",this.searchValue);
        if(this.prev_sort != ctx.sortBy){
          this.prev_sort = ctx.sortBy
          this.currentPage = 1
        }
        this.getNetworkGroupList();
      },
      onDisplayChange(){
        console.log(this.networkListTotal,this.perPage,this.networkList.length,(this.networkList.length < this.networkListTotal && this.networkList.length != this.perPage));
        if(
          (this.networkList.length < this.networkListTotal && this.networkList.length != this.perPage) || // condition for incrementing display per page
          (this.networkList.length == this.networkListTotal && this.perPage < this.networkList.length) // condition for decreasing display per page
          ){
          this.onPageUpdate('reset')
        }
      },
      editNetwork(item){
        console.log(">> EDIT:", item);
        this.$router.push(
          this.$route.query.redirectFrom || {
            name: "E-Load Core Network Form", params: { id: item.networkId }
          }
        );
      },
      async toggleNetworkStatus(item, event) {
        // Immediately revert the checkbox to prevent visual change
        event.target.checked = item.status == 'a';
       
        const currentStatus = item.status;
        const newStatus = currentStatus == 'a' ? 'i' : 'a';
        const statusText = newStatus == 'a' ? 'activate' : 'deactivate';
        
        Swal.fire({
          title: 'Are you sure?',
          text: `Do you really want to ${statusText} this network?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#6f42c1',
          cancelButtonColor: '#dc3545',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          customClass: {
            popup: 'swal-popup',
            confirmButton: 'btn btn-primary px-4',
            cancelButton: 'btn btn-danger px-4'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            this.actionCoreEloadNetworkAPIPOST({
              params: {
                id: item.networkId,
                status: newStatus
              },
              action: "update"
            })
            .then((res) => {
              console.log(res);
              Swal.fire({
                title: 'Updated Successful!',
                text: `${item.name} is successfully ${statusText}d.`,
                icon: 'success',
                confirmButtonColor: '#6f42c1',
                confirmButtonText: 'OK',
                customClass: {
                  popup: 'swal-popup',
                  confirmButton: 'btn btn-primary'
                }
              });
              // Update the status in the data and refresh
              this.onSearch();
            }).catch((e) => {
              Swal.fire({
                title: 'Update Failed!',
                text: `An error occurred while updating the network.`,
                icon: 'error',
                confirmButtonColor: '#dc3545',
                confirmButtonText: 'OK',
                customClass: {
                  popup: 'swal-popup',
                  confirmButton: 'btn btn-danger'
                }
              });
              console.log("error while updating network status", e);
            });
          }
          // If user clicks "No", checkbox remains in original state (already reverted above)
        });
      },
      async onExport(){
        await this.getNetworkGroupList();
        if(this.networkListTotal == 0){
          Swal.fire("Failed!", this.exportNullPrompt, "warning");
          return;
        }
        let params = {
          email: JSON.parse(localStorage.getItem('userData')).email,
          orderDesc: this.searchValue.orderDesc,
          search: this.searchValue.search,
          searchField: this.searchValue.searchField,
          sort: this.searchValue.sort,
          status: this.searchValue.status,
        };
        
        this.actionCoreEloadNetworkAPIPOST({
          params: params,
          action: "export"
        })
        .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
        .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
      }
    }
  }
    
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-4 col-sm-4">
                <div class="mt-2">
                  <h5 class="card-title">
                    <span class="fw-normal ms-2"
                      >{{networkListTotal}}</span
                    > Record(s)
                  </h5>
                </div>
              </div>
              <!-- end col -->

              <!-- Search and button -->
              <div class="col-md-8 col-sm-8"> 

                <div class="d-flex justify-content-end">
                    <div>
                      <!-- <b-button v-b-modal.bv-modal-create-network variant="primary" class="me-2" v-if="false"><i class="uil uil-plus me-1"></i> Add Network</b-button>-->
                      <router-link :to="{ name: 'E-Load Core Network Form', params: { id: 0 }}" class="tc-white me-2">
                        <button class="btn btn-primary" v-if="eloadNetworkGroupModule.access.create">
                            <i class="uil uil-plus me-1"></i> Add Network
                        </button>
                      </router-link> 

                      <a class="btn btn-secondary" @click="onPageUpdate()"
                        ><feather
                          type="refresh-ccw"
                          size="16"
                          class="icon nav-icon"
                        ></feather
                        >&nbsp;&nbsp; Refresh</a
                      >
                    </div>
                </div>
              </div>

              <div class="col-md-12 col-sm-12">
                 <div class="row mt-4">
                    <div class="col-md-4 ta-right">
                      <b-form-group description="Search Keyword">
                        <form class="d-flex" @submit.prevent="onSearch()">
                          <b-form-group id="input-group-3" label-for="input-3">
                            <b-form-select
                              class="form-select rounded-0 rounded-start shadow-none"
                              style="width: fit-content"
                              id="input-3"
                              v-model="searchValue.searchField"
                              :options="searchListNetwork"
                            ></b-form-select>
                          </b-form-group>

                          <b-input-group>
                            <b-form-input
                              class="rounded-0"
                              v-model="searchValue.search"
                            ></b-form-input>
                          </b-input-group>
                        </form>
                      </b-form-group>
                    </div>
                    <div class="col-md-8">
                      <div class="d-flex align-items-start mt-2 mt-md-0 gap-2 mb-3 ta-right">
                        <b-form-group label-for="status" description="Filter by status">
                          <b-form-select class="form-select rounded-0 rounded-start shadow-none"
                            v-model="searchValue.status"
                            :options="statusList"
                          ></b-form-select>
                        </b-form-group>
                        <a class="btn btn-primary h-fit" @click="onPageUpdate('reset')">
                          <i class='bx bx-search bx-fw'></i>Search
                        </a>
                        <a
                          class="btn btn-primary"  @click="onExport"
                        >
                          <i class="uil uil-export me-1"></i>
                          Export
                        </a>
                      </div>
                    </div>

                </div>

              </div> <!-- end of list of filter-->
              <!-- end col -->
            </div>
            <!-- end row -->

            <!-- table responsive -->
            <div class="table-responsive">
              <div class="table align-middle table-nowrap">
                <b-table
                  :items="networkList"
                  :fields="fieldsNetwork"
                  responsive="sm"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter-included-fields="filterOn"
                  @sort-changed="eloadNetworkSort"
                >

                  <template #cell(name)="data">
                    <b-link
                      class="fw-medium"
                      @click="editNetwork(data.item)"
                      >{{ data.item.name }}</b-link
                    >
                  </template>
                  <template #cell(image)="data">
                    <img
                    :src="data.item.networkImageSrc"
                    alt="Network Image"
                    @error="(e) => e.target.src = require('@/assets/images/img-placeholder.png')"
                    class="border-end img-fluid border-0 rounded-start img-cover"
                    style="width: 60px;"
                    />
                  </template>
                  <template #cell(status)="data">
                    <!-- <p
                      v-bind:class="
                        data.item.status=='a'
                          ? 'text-success m-0'
                          : 'text-danger m-0'
                      "
                    >
                      {{ data.item.status == 'i' ? "Inactive" : "Active" }}
                    </p> -->
                    <span :class="`${data.item.status  == 'a' ?  'text-success': 'text-disabled'}`">
                            <div 
                            class="form-check form-switch form-switch-md mb-1 float-right mr-3" 
                            dir="ltr">
                            <label class="form-check-label form-label small" for="customSwitchsizem">Active</label>
                            <input
                                type="checkbox"
                                class="form-check-input"
                                :id="`statusSwitch_${data.item.networkId}`"
                                :checked="data.item.status == 'i' ? false : true"
                                @change="toggleNetworkStatus(data.item, $event)"
                            />
                        </div>
                    </span>
                  </template>
                  <!-- <template #cell(apiEndPoint)="data">
                    <b-link
                      class="fw-medium"
                      >{{ data.item.api_endpoint }}</b-link
                    >
                  </template> -->
                </b-table>
              </div>
            </div>
            <!-- end table responsive -->
            <div class="row g-0 text-center" v-if="networkListTotal == 0">
              <span>No data to display.</span>
            </div>
            <div class="row g-0 text-center text-sm-start" v-if="networkListTotal != 0 && networkListTotal > 10">
              <!-- end col -->
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <div class="form-group row pull-left">
                      <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                      <div class="col-sm-6">
                        <b-form-group label-for="display-record">
                          <b-form-select class="form-select shadow-none w-fit"
                            id="display-record"
                            v-model="perPage"
                            :options="pageOptions"
                            @change="onDisplayChange()"
                          ></b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                    <div
                      class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-end
                      "
                      v-if="networkListTotal > perPage"
                    >
                      <b-pagination
                        class="pagination-rounded"
                        v-model="currentPage"
                        @input="getNetworkGroupList()"
                        :total-rows="networkListTotal"
                        :per-page="perPage"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>

          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>   
  </div>
</template>